import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalDelDialog } from './ModalDelDialog'
import { ModalEditDialog } from './ModalEditDialog'
import EditIconImg from '../images/EditIcon.png'

type ItemButtonProps = {
  title: string
  id: string
  text: string
  onDel: (id: string) => void
  onUpdate: (oldText: string, newText: string) => void
}

export const ItemButton: React.FC<ItemButtonProps> = ({ title, text, id, onDel, onUpdate }) => {
  const auth = useAuth()
  const [openDel, setOpenDel] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const handleCloseDel = () => {
    setOpenDel(false)
    setIsFocused(false)
  }
  const handleDel = () => {
    onDel(id)
    handleCloseDel()
  }
  const handleCloseEdit = () => {
    setOpenEdit(false)
    setIsFocused(false)
  }
  const handleSaveEdit = (newText: string) => {
    onUpdate(text, newText)
    handleCloseEdit()
  }

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  useEffect(() => {
    setIsFocused(false)
  }, [])

  return (
    <>
      {openEdit && (
        <ModalEditDialog
          open={openEdit}
          title={title}
          id={id}
          text={text}
          onClose={handleCloseEdit}
          onSave={handleSaveEdit}
        />
      )}
      {openDel && (
        <ModalDelDialog
          open={openDel}
          title={title}
          id={id}
          text={text}
          onClose={handleCloseDel}
          onDel={handleDel}
        />
      )}

      <Button
        component="div"
        disableRipple
        disableFocusRipple
        disableElevation
        tabIndex={-1}
        role={undefined}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          marginBottom: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          color: isHovered ? '#282828' : '#FFFFFF',
          backgroundColor: '#282828',
          '&:hover': {
            backgroundColor: 'rgba(241, 241, 241)',
            opacity: 0.8,
          },
          paddingTop: '6px',
          paddingLeft: '38px',
          paddingRight: '8px',
          textAlign: 'left',
          height: '80px',
          width: '400px',
          borderRadius: '40px',
          cursor: 'default',
        }}
      >
        <Tooltip title={text} enterTouchDelay={0}>
          <Typography
            sx={{
              textTransform: 'none',
              font: 'normal normal normal 21px/32px Noto Sans JP',
              fontSize: '21px',
              lineHeight: '32px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '300px',
            }}
          >
            {text}
          </Typography>
        </Tooltip>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: 96,
            visibility: isHovered ? 'visible' : 'hidden',
          }}
        >
          <IconButton
            onClick={() => setOpenEdit(true)}
            disabled={auth.isDisable}
            aria-label="edit"
          >
            <img src={EditIconImg} width="25px" height="25px" alt="edit" />
          </IconButton>

          <IconButton
            onClick={() => setOpenDel(true)}
            disabled={auth.isDisable}
            sx={{
                  color: 'red',
                  '& .MuiSvgIcon-root': {
                    fontSize: '40px',
                  },
            }}
            aria-label="delete"
          >
            <HighlightOffIcon />
          </IconButton>
        </Box>
      </Button>
    </>
  )
}